// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.termsandconditions.TermType

export enum TermType {
  /**
   * @deprecated
   */
  CHECKR_TAC_LANDLORD = 'CHECKR_TAC_LANDLORD',
  /**
   * @deprecated
   */
  CHECKR_TAC_RENTER = 'CHECKR_TAC_RENTER',
  CIC_CONFIRMATION_RENTER = 'CIC_CONFIRMATION_RENTER',
  CIC_TAC = 'CIC_TAC',
  EXPERIAN_CIC_WRITTEN_CONSENT_RENTER = 'EXPERIAN_CIC_WRITTEN_CONSENT_RENTER',
  EXPERIAN_PRIVACY_POLICY = 'EXPERIAN_PRIVACY_POLICY',
  EXPERIAN_TAC = 'EXPERIAN_TAC',
  EXPERIAN_WRITTEN_CONSENT_LANDLORD = 'EXPERIAN_WRITTEN_CONSENT_LANDLORD',
  EXPERIAN_WRITTEN_CONSENT_RENTER = 'EXPERIAN_WRITTEN_CONSENT_RENTER',
  TERMS_ZILLOW_RENTAL_USER = 'TERMS_ZILLOW_RENTAL_USER',
  ZILLOW_RENTAL_PLAID_CHECK_TERMS = 'ZILLOW_RENTAL_PLAID_CHECK_TERMS',
}

export const TermType_values = [
  TermType.CHECKR_TAC_LANDLORD,
  TermType.CHECKR_TAC_RENTER,
  TermType.CIC_CONFIRMATION_RENTER,
  TermType.CIC_TAC,
  TermType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER,
  TermType.EXPERIAN_PRIVACY_POLICY,
  TermType.EXPERIAN_TAC,
  TermType.EXPERIAN_WRITTEN_CONSENT_LANDLORD,
  TermType.EXPERIAN_WRITTEN_CONSENT_RENTER,
  TermType.TERMS_ZILLOW_RENTAL_USER,
  TermType.ZILLOW_RENTAL_PLAID_CHECK_TERMS,
] as const;
